import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { NgForm } from "@angular/forms";
import { LocalstorageService } from "../localstorage.service";
import { UserService } from "../user.service";
import { ElementRef, Renderer2 } from "@angular/core";

@Component({
    selector: "app-editechexmerchantuser",
    templateUrl: "./editechexmerchantuser.component.html",
    styleUrls: ["./editechexmerchantuser.component.css"]
})
export class EditechexmerchantuserComponent implements OnInit {
    @ViewChild("f") profileUpdates: NgForm;
    
    profile: any = {};
    public mask: Array<string | RegExp>;
    public token: string;
    public user_id: string;
    public role_id: string;

    //twofactor
    public imageurl: string;
    busy: Subscription;

    //Validation
    public invalidEmalAddress: boolean = false;
    public signature_validation: boolean = false;
    public val_type_signature: boolean = false;

    //profile update
    public validationFirstname: boolean = false;
    public validationLastname: boolean = false;
    public validationEmail: boolean = false;
    public invalidEmail: boolean = false;
    public validationPhone: boolean = false;
    public match: boolean = false;

    public imageValidate: boolean = false;
    public vendorimgValidate: boolean = false;
    public recurringInvoiceList: any = [];
    public key: string;

    public formTouched: boolean = false;

    //recuring
    NamecharacterLimitReached: { [key: string]: boolean } = {};
    isDialogOpen: boolean = false;

    constructor(
        protected route: ActivatedRoute,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        protected router: Router,
        protected toastr: ToastrService,
        protected userService: UserService,
        protected localStorageService: LocalstorageService,
    ) {
        this.mask = [
            "(",
            /[1-9]/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ];
        this.router = router;
        var currentUser = this.localStorageService.getData("currentUserToken");
        this.token = currentUser.data.user_token;
        let params: any = this.route.snapshot.params;
        this.user_id = params.id;
    }

    ngOnInit() {
        this.getprofileDetails();
    }

    // Get Profile details
    getprofileDetails() {
        var data = {
            token: this.token,
            id: this.user_id
        };
        var url = this.router.url;

        let profileData = <any>{};
        this.busy = this.userService.getProfileData(data).subscribe(
            response => {
                profileData = response;
                this.profile = profileData.data;
            },
            error => {
                profileData = error;
                this.toastr.error(profileData.error.message, "Failed!");
            }
        );
    }

    NameCharacterLimit(event: any, fieldName: string, limit: number) {
        const maxTextLength = 25; // Maximum text length of 20 characters
        const inputChar = event.key;
        const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter"];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

        if (
            allowedKeys.indexOf(event.key) !== -1 ||
            allowedKeyCodes.indexOf(event.keyCode) !== -1
        ) {
            return;
        }

        const inputValue = event.target.value;

        if (inputValue.length >= maxTextLength) {
            if (allowedKeys.indexOf(inputChar) === -1) {
                this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
                setTimeout(() => {
                    this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
                }, 3000);
                event.preventDefault(); // Prevent entering the exceeded character
            }
        }
    }

    isNameLimitReached(fieldName: string): boolean {
        return this.NamecharacterLimitReached[fieldName];
    }

    handleTabClick(tabTitle: string) {
        if (tabTitle === "Merchant User Profile") {
            setTimeout(() => {
                const businessNameElement = document.querySelector(
                    "#mfirst_name"
                ) as HTMLInputElement;
                if (businessNameElement) {
                    this.renderer
                        .selectRootElement(businessNameElement)
                        .focus();
                }
            }, 0);
        }
    }

    eventHandler() {
        this.validationFirstname = false;
        this.validationLastname = false;
        this.validationEmail = false;
        this.validationPhone = false;
        this.match = false;
    }

    fileToUpload: File = null;

    //update profile
    updateProfile(data) {
        this.focusFirstInvalidControlPlus(); //focus field
        if (data.valid) {
            let model: any = data.value;
            model.id = this.user_id;
            model.token = this.user_id;
            model.user_token = this.token;

            const formData = new FormData();
            if (this.fileToUpload) {
                formData.append(
                    "photo",
                    this.fileToUpload,
                    this.fileToUpload.name
                );
            }
            // Image validation
            if (this.imageValidate === true) {
                return;
            }
            if (this.vendorimgValidate === true) {
                return;
            }

            Object.entries(model).forEach(([key, value]) => {
                formData.append(key, value as any);
            });

            let updateProfileData = <any>{};
            this.busy = this.userService
                .updateProfile(model, formData)
                .subscribe(
                    response => {
                        updateProfileData = response;
                        this.toastr.success(
                            updateProfileData.message,
                            "Success!"
                        );
                        this.getprofileDetails();
                    },
                    error => {
                        updateProfileData = error;
                        this.toastr.error(
                            updateProfileData.error.message,
                            "Failed!"
                        );
                    }
                );
        }
    }

    focusFirstInvalidControlPlus(): void {
        const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(
            `form .ng-invalid`
        );
        if (firstElementWithErrors) {
            firstElementWithErrors.focus();
        }
    }

    @ViewChild('submitButton') submitButton: ElementRef;
    @ViewChild('Send_otp') Send_otp: ElementRef;
    moveNext(nextInput: HTMLInputElement, checkbox: number) {
        if(checkbox === 3){
          const saveButton = document.getElementById('submitOTP') as HTMLElement;
            if (saveButton) {
              saveButton.focus();
              saveButton.click();
            }
        } else if(checkbox === 12){
            if (this.Send_otp && this.Send_otp.nativeElement) {
                this.Send_otp.nativeElement.focus();
                this.Send_otp.nativeElement.click();
              }
        } else if(checkbox === 2){
            if (this.submitButton && this.submitButton.nativeElement) {
                this.submitButton.nativeElement.focus();
                this.submitButton.nativeElement.click();
              }
        } else{
          nextInput && nextInput.focus();
        }
      }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/editechexmerchantuser/editechexmerchantuser.component.ts